"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M21 7h-2V5c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v2H3c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-3h4v3c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zM11 9c0 .55-.45 1-1 1H9v1h1.5c.28 0 .5.22.5.5s-.22.5-.5.5H9c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1V8H8.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5H10c.55 0 1 .45 1 1v1zm5 2.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V10h-1c-.55 0-1-.45-1-1V7.5c0-.28.22-.5.5-.5s.5.22.5.5V9h1V7.5c0-.28.22-.5.5-.5s.5.22.5.5v4z"
}), 'LocalConvenienceStoreRounded');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/LocalConvenienceStoreRounded.js
// module id = 3666
// module chunks = 0